import { CSSProperties } from "react";

type StatusVariant = "success" | "danger" | "warning" | "secondary";

const variantStyles: Record<StatusVariant, CSSProperties> = {
  success: { backgroundColor: "#e7f7ed", color: "#16a34a" },
  danger: { backgroundColor: "#fdecea", color: "#c62828" },
  warning: { backgroundColor: "#fff8e1", color: "#a16207" },
  secondary: { backgroundColor: "#e9ecef", color: "#6c757d" }
};

const AIBillingStatusPill = ({
  label,
  variant,
  size = "small"
}: {
  label: string;
  variant: StatusVariant;
  size?: "small" | "large";
}) => {
  const { backgroundColor, color } = variantStyles[variant];
  const isLarge = size === "large";
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: isLarge ? 7 : 5,
        padding: isLarge ? "4px 12px" : "2px 9px",
        borderRadius: isLarge ? 14 : 12,
        fontSize: isLarge ? "1rem" : "0.6875rem",
        fontWeight: 500,
        letterSpacing: 0,
        backgroundColor,
        color
      }}
    >
      <span
        style={{
          width: isLarge ? 9 : 7,
          height: isLarge ? 9 : 7,
          borderRadius: "50%",
          backgroundColor: "currentColor",
          display: "inline-block"
        }}
      />
      {label}
    </span>
  );
};

export default AIBillingStatusPill;
